"use client";

import {
  Map,
  AdvancedMarker,
  useAdvancedMarkerRef,
  useApiIsLoaded,
} from "@vis.gl/react-google-maps";
import { Spinner } from "@/components/util";
import { MapPin } from "./map-pin";
import { useMapWidget, UseMapWidgetProps } from "./use-map-widget";

export type MapWidgetProps = UseMapWidgetProps;

export const MapWidget = (props: MapWidgetProps) => {
  const { styles, className, mapId, zoom, location } = useMapWidget(props);
  const [markerRef] = useAdvancedMarkerRef();
  const apiIsLoaded = useApiIsLoaded();

  if (!apiIsLoaded) {
    return (
      <div className={styles.loader()}>
        <Spinner color="white" size="md" />
      </div>
    );
  }

  return (
    <Map
      className={styles.base({ className })}
      mapId={mapId}
      defaultCenter={location}
      defaultZoom={zoom}
      fullscreenControl={true}
      zoomControl={true}
      disableDefaultUI={true}
      gestureHandling="cooperative"
      backgroundColor="#f6f7f9"
    >
      <AdvancedMarker
        ref={markerRef}
        position={{
          lat: location.lat,
          lng: location.lng,
        }}
      >
        <MapPin />
      </AdvancedMarker>
    </Map>
  );
};
